import React, { useState } from 'react';
import { Box, Button, Stack, TextField } from '@mui/material';
import { Form, FormikProvider, useFormik } from 'formik';
import * as Yup from 'yup';
import { useSnackbar } from 'notistack';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import GlobalDialog from '../../../components/mui/Dialogue/GlobalDialog';
import { CancelButton, UpdateButton } from '../../../components/mui/Buttons/Buttons';
import GlobalSelectField from '../../../components/mui/GlobalSelectField';
import { approveQuotation, getQuotationRequirements, holdOrReject } from '../../../redux/features/assetManagementSlice';
import { Icon } from '@iconify/react/dist/iconify.js';
export const QuotationstatusOptions = [
  { id: 2, value: 'Rejected' },
  { id: 3, value: 'Hold' },
];
const StatusChangeWithRemarksQuotation = ({
  quotationId,
  isClosed,
  dispatchParams,
  isApproval,
  row,
  afterSuccessStatusChange,
}) => {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { loading } = useSelector((store) => store.crd);
  const initialValues = {
    quotationStatusId: row ? row?.quotationStatus : '',
    remarks: row ? row?.holdRemarks == null ? '' : row?.holdRemarks : '',
  };
  const schema = Yup.object({
    remarks: Yup.string().required('Remarks is required'),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: schema,
    onSubmit: (values) => {
      const data = {
        remarks: values.remarks,
        status: values.quotationStatusId,
        quotationId: quotationId,
      };

      dispatch(holdOrReject(data)).then((res) => {
        if (res.payload.status === 'error') {
          enqueueSnackbar(res.payload.message, {
            variant: 'error',
          });
        } else if (res.payload.status === 'success') {
          afterSuccessStatusChange();
          handleCancel();
          enqueueSnackbar(res.payload.message, {
            variant: 'success',
          });
        }
      });
    },
  });

  const handleCancel = () => {
    setOpen(false);
    formik.resetForm();
  };

  return (
    <GlobalDialog
      maxWidth={'sm'}
      fullWidth
      title={'Quotation Status Change with Remarks'}
      open={open}
      setOpen={setOpen}
      closeButton={true}
      closeCondition={handleCancel}
      popupButton={
        <>
          <Button
            disabled={isClosed || isApproval}
            size="small"
            color="warning"
            variant="outlined"
            onClick={() => {
              setOpen(true);
            }}
            startIcon={<Icon style={{ marginRight: '3px' }} icon="grommet-icons:update" width="20" height="24" />}
          >
            Hold/Reject
          </Button>
        </>
      }
      content={
        <>
          <>
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <Stack gap={2}>
                  <Box>
                    <GlobalSelectField
                      options={{
                        formik: formik,
                        label: 'Quotation Status',
                        name: 'quotationStatusId',
                        data: QuotationstatusOptions,
                        keys: {
                          id: 'id',
                          value: 'value',
                        },
                        sx: {
                          width: '100%',
                        },
                      }}
                    />
                  </Box>
                  <Box>
                    <TextField
                      autoComplete="off"
                      fullWidth
                      id="remarks"
                      label="Remarks"
                      name="remarks"
                      value={formik.values.remarks}
                      onChange={formik.handleChange}
                      error={formik.touched.remarks && Boolean(formik.errors.remarks)}
                      helperText={formik.touched.remarks && formik.errors.remarks}
                    />
                  </Box>
                </Stack>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                  <Stack direction={'row'} spacing={1}>
                    <CancelButton action={() => handleCancel()}>Cancel</CancelButton>

                    <UpdateButton disabled={loading} type="submit">
                      {loading ? 'Updating...' : 'Update'}
                    </UpdateButton>
                  </Stack>
                </Box>
              </Form>
            </FormikProvider>
          </>
        </>
      }
    />
  );
};

export default StatusChangeWithRemarksQuotation;
